// extracted by mini-css-extract-plugin
export default {"modal":"Invite_modal__00Oq5","changerolemodal":"Invite_changerolemodal__5UJji","emailtag":"Invite_emailtag__c2uEb"};